import { Button } from "@chakra-ui/react"
import { IconName } from "@pathwright/pathicons"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import { usePublish } from "./StepPublishProvider"
import { stepPublishStatuses } from "./utils"

export const StatusIconButton = ({
  icon,
  iconOnly,
  className
}: {
  icon: IconName
  iconOnly?: boolean
  className?: string
}) => {
  return (
    <Button
      display="flex"
      alignItems="center"
      height="20px"
      p={0}
      m="0 10px"
      color="rgb(170, 170, 170)"
      fontSize="1.2em"
      cursor={iconOnly ? "default" : "pointer"}
      bg="transparent"
      className={`StepPublish__status-icon ${className}`}
      variant="link"
      _hover={
        iconOnly
          ? undefined
          : {
              ".Pathicon": {
                opacity: "0.9"
              }
            }
      }
      _active={{
        bg: iconOnly ? "transparent" : ""
      }}
    >
      <Pathicon
        icon={icon}
        style={{
          top: 0
        }}
      />
    </Button>
  )
}

export const PublishIcon = ({ iconOnly }: { iconOnly?: boolean }) => {
  const { publishStatus } = usePublish()

  let icon = "" as IconName
  let alwaysVisible = true

  if (publishStatus === stepPublishStatuses.published) {
    icon = "cloud-fill"
    alwaysVisible = false
  } else if (publishStatus === stepPublishStatuses.contentEmpty) {
    icon = "block-notification"
  } else if (
    publishStatus === stepPublishStatuses.contentUnpublished ||
    publishStatus === stepPublishStatuses.contentDraft
  ) {
    icon = "block-notification-fill"
  } else if (publishStatus === stepPublishStatuses.newStep) {
    icon = "cloud"
  } else {
    icon = "cloud-notification-fill"
  }

  return (
    <StatusIconButton
      iconOnly={iconOnly}
      icon={icon}
      className={alwaysVisible ? `always-visible` : ""}
    />
  )
}

export const SyncIcon = ({ iconOnly }: { iconOnly?: boolean }) => {
  const { syncStatus } = usePublish()

  let className = ""

  const icon =
    syncStatus === "changed" ||
    syncStatus === "changed-viewonly" ||
    syncStatus === "unique"
      ? "cloud-asterisk-fill"
      : syncStatus === "synced" || syncStatus === "synced-viewonly"
      ? "cloud-arrows-fill"
      : "cloud-fill"
  if (syncStatus === "changed" || syncStatus === "unique") {
    className = `always-visible`
  }

  return (
    <StatusIconButton iconOnly={iconOnly} icon={icon} className={className} />
  )
}
